var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "coming-soon" },
    [
      _c("v-icon", { attrs: { size: "56", color: "primary" } }, [
        _vm._v("mdi-clock-outline"),
      ]),
      _c("p", { staticClass: "coming-soon__text" }, [
        _vm._v("Próximamente..."),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }